//import router from '@/router'
import store from '@/store';
import ElementUI from "element-ui";
const EUIMsgBoxOption = {
  title: '警告',
  message: '無登入資訊',
  type: 'warning',
  confirmButtonText: '確定',
  closeOnPressEscape: false,
  showClose: false,
  closeOnClickModal: false
};
const errorResponseHandler = {
  fulfilled: function (response) {
    // Do something with response data    
    return response;
  },
  rejected: function (error) {
    let reloadYn = false;
    let reCheckAccountYn = false;
    let todayNow = new Date();
    let msg = '時間:' +  todayNow.toLocaleDateString('zh-Hant-TW') + ' ' + todayNow.toLocaleTimeString('zh-Hant-TW') + ' , ';
    if (error.response) {
      const {errors} = error.response.data;      
      let allListErr = [];
      let allErrorText = '';
      switch (error.response.status) {
        case 400: //400 Bad Request ,參數問題被攔截後的訊息
          //msg = msg + '400-參數錯誤，請聯絡IT人員';          
          if(errors){            
            for(let k in errors){
              let itemErr = errors[k];
                 if(itemErr && itemErr.length >0){                    
                    Array.prototype.push.apply(allListErr, itemErr);
                 }
            }
          }
          allErrorText = allListErr.join(' , '); 
          if(!allErrorText){
            allErrorText = '400-參數錯誤，請聯絡IT人員';
          }
          msg = msg + allErrorText;
          console.error(msg);          
          break;
        case 401: //401 Unauthorized                    
          store.commit('set', ['loginAccount', null ] );
          msg = msg + '401-無此請求權限，請聯絡IT人員';
          reCheckAccountYn = true;
          //location.reload(); //
          //return;
          break;
        case 403: //403 Forbidden
          msg = msg + '403-伺服器連線錯誤，請聯絡IT人員';
          console.error(error.response);
          break;
        case 404: //404 Not Found
          msg = msg + '404-無法找到此網址，請聯絡IT人員';
          console.error(error.response);
          break;
        case 500: //500 Internal Server Error
          msg = msg + '500-系統程式發生錯誤，請聯絡程式人員';
          console.error(error.response);
          break;
        default:
          msg = msg + error.response.status + '-系統程式發生錯誤，請聯絡程式人員';
          break;
      }
    } else {
      msg = msg + '999-系統連不上，請確認網路狀況與環境問題';
    }
    store.commit('LOADING', false);
    let actionStep = null;
    if(reCheckAccountYn){//重新檢核使用者身分，若無使用者則導回預設主頁
      actionStep = store.dispatch('currentUser',{});
    }
    if (msg != null) {      
      EUIMsgBoxOption.message = msg;
      ElementUI.MessageBox(EUIMsgBoxOption).then(() => { 
         if (reloadYn) {
            window.location.reload();
         }else{
            if(actionStep !=null){
              actionStep.then(() => {
                let userInfo = store.getters['userInfo'];  
                let redirectUrl = store.getters['redirectUrl'];
                if(redirectUrl){
                  redirectUrl += '?RocRedirect=' + encodeURIComponent(location.href);  
                }else{                  
                  redirectUrl = 'about:blank';
                }
                if(!(userInfo && userInfo.account)){
                  location.href = redirectUrl;
                }
              });
            }
         }
      });
      // alert(msg).then(() => {
      //   if (reloadYn) {
      //     window.location.reload();
      //   }
      // });
    }
    return Promise.reject(error);
  }
}
export default errorResponseHandler
